/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import { jsx } from 'react/jsx-runtime';
import { prop } from './IPropertyTransformer.js';
import { view } from './view.js';

/**
 * A component that renders an observable ReactNode value.
 * Re-renders when the observable changes.
 * Usage: <Value value={myObservable} />
 */
const Value = view({ value: prop.obs() }, (reader, props) => {
    return props.value.read(reader);
});
/**
 * Helper function to render an observable as inline JSX.
 * Usage: {val(myObservable)}
 */
function val(v) {
    return jsx(Value, { value: v });
}

export { Value, val };
//# sourceMappingURL=Value.js.map
